import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";

const NavigationTab: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Define routes and their display names
    const tabs = [
        { name: "home", path: "/home" },
        { name: "User Management", path: "/usermanagement" },
        { name: "Cluster Flashing", path: "/cluster_flashing" },
        { name: "Controller Flashing", path: "/controller_flashing" },
        // { name: "Password Request", path: "/passwordreqmanagement" },
    ];

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                padding: "20px",
            }}
        >
            {tabs.map((tab) => (
                <Button
                    key={tab.path}
                    sx={{
                        color: location.pathname === tab.path ? "red" : "black",
                        background: location.pathname === tab.path ? "#ffffff9e" : "transparent",
                        mx: 2,
                        fontWeight: location.pathname === tab.path ? "bold" : "normal",
                        position: "relative",
                        "&::after": location.pathname === tab.path
                            ? {
                                content: '""',
                                position: "absolute",
                                bottom: "-4px",
                                left: 0,
                                width: "100%",
                                height: "3px",
                                backgroundColor: "red",
                            }
                            : undefined,
                    }}
                    variant="text"
                    onClick={() => navigate(tab.path)}
                >
                    {tab.name}
                </Button>
            ))}
        </Box>
    );
};

export default NavigationTab;
